import { FaVolleyballBall, FaBaseballBall, FaRunning } from "react-icons/fa";

import { GiTennisCourt } from "react-icons/gi";
// Hero Image
import heroImage from "../assets/services/badminton/hero.jpg";
import overview1 from "../assets/services/badminton/overview1.webp";
import overview2 from "../assets/services/badminton/overview2.webp";
import overview3 from "../assets/services/badminton/overview3.webp";
import overview4 from "../assets/services/badminton/overview4.webp";
/* =====================================================
   HERO STATS
===================================================== */

// Gallery Images
import gallery1 from "../assets/services/badminton/gallery1.webp";
import gallery2 from "../assets/services/badminton/gallery2.webp";
import gallery3 from "../assets/services/badminton/gallery3.webp";
import gallery4 from "../assets/services/badminton/gallery4.webp";

const badmintonData = {
  /* =====================================================
     HERO
  ====================================================== */

  slug: "badminton",

  title: "Badminton Court Construction",

  subtitle:
    "Professional Acrylic, Wooden and PVC mat Badminton Courts Built to BWF Standards",

  heroImage,

  overviewImages: [overview1, overview2, overview3, overview4],

  heroStats: [
    {
      value: "550+",
      label: "Courts Built",
    },

    {
      value: "15+",
      label: "Years Experience",
    },

    {
      value: "BWF",
      label: "Certified/Standard",
    },

    {
      value: "1-2 Yr",
      label: "Warranty",
    },
  ],

  breadcrumb: ["Home", "Services", "Badminton Court"],

  /* =====================================================
     OVERVIEW
  ====================================================== */

  overview: {
    title: "Professional Badminton Court Construction",

    description:
      "Quality Sports Surface specializes in designing and constructing international-standard badminton courts for schools, colleges, universities, sports academies, clubs, residential communities, and professional sports facilities. We use premium acrylic and wooden sports flooring systems engineered for durability, player safety, weather resistance, and exceptional performance.",
  },

  /* =====================================================
     BENEFITS
  ====================================================== */

  benefits: [
    {
      title: "BWF Standard Construction",
      description:
        "Designed according to international badminton court specifications.",
    },
    {
      title: "Premium Acrylic Surface",
      description:
        "High-performance acrylic flooring with excellent grip and durability.",
    },
    {
      title: "UV & Weather Resistant",
      description:
        "Built to withstand India's harsh climate and heavy rainfall.",
    },
    {
      title: "Low Maintenance",
      description:
        "Minimal maintenance with long-lasting color and surface quality.",
    },
  ],

  /* =====================================================
     CONSTRUCTION PROCESS
  ====================================================== */

  process: [
    {
      step: "01",
      title: "Site Inspection",
      description:
        "Complete site survey, measurements, and technical planning.",
    },

    {
      step: "02",
      title: "Base Preparation",
      description:
        "Concrete or asphalt base preparation with perfect leveling.",
    },

    {
      step: "03",
      title: "Acrylic Coating",
      description:
        "Multiple acrylic layers applied for strength and cushioning.",
    },

    {
      step: "04",
      title: "Court Marking",
      description: "Accurate FIBA-standard basketball court line marking.",
    },

    {
      step: "05",
      title: "Final Inspection",
      description: "Complete quality inspection before project handover.",
    },
  ],

  /* =====================================================
     TECHNICAL SPECIFICATIONS
  ====================================================== */

  specifications: [
    {
      icon: "🏸",
      feature: "Surface Type",
      value: "Premium Acrylic / Synthetic Flooring",
    },

    {
      icon: "🌧️",
      feature: "Weather Resistance",
      value: "Excellent (All-Weather)",
    },

    {
      icon: "👟",
      feature: "Slip Resistance",
      value: "High Grip Finish",
    },

    {
      icon: "☀️",
      feature: "UV Resistant",
      value: "100% UV Stable",
    },

    {
      icon: "🏆",
      feature: "BWF Standard",
      value: "International Compliant",
    },

    {
      icon: "⏳",
      feature: "Expected Lifespan",
      value: "5+ Years",
    },

    {
      icon: "⚒️",
      feature: "Maintenance",
      value: "Low Maintenance",
    },

    {
      icon: "🌍",
      feature: "Court Type",
      value: "Indoor & Outdoor",
    },
  ],

  /* =====================================================
     GALLERY
  ====================================================== */

  gallery: [
    {
      image: gallery1,
      title: "ABC International School",
      location: "New Delhi",
      surface: "Premium Acrylic Basketball Court",
      year: "2025",
    },

    {
      image: gallery2,
      title: "Delhi Public School",
      location: "Jaipur",
      surface: "Professional Acrylic Court",
      year: "2024",
    },

    {
      image: gallery3,
      title: "Sports Academy",
      location: "Lucknow",
      surface: "Outdoor Basketball Court",
      year: "2024",
    },

    {
      image: gallery4,
      title: "University Campus",
      location: "Chandigarh",
      surface: "FIBA Standard Court",
      year: "2023",
    },
  ],

  /* =====================================================
   WHY CHOOSE US — BADMINTON
====================================================== */

  whyChoose: {
    tag: "WHY CHOOSE US",

    title: "Why Choose Our Professional Badminton Wooden Flooring?",

    description:
      "We provide high-performance wooden flooring systems designed specifically for indoor badminton courts, combining player safety, shock absorption, controlled grip and consistent playing performance. From premium hardwood selection to precision installation and professional court finishing, we deliver complete badminton flooring solutions.",

    features: [
      {
        title: "15+ Years Experience",
        description:
          "Over 15 years of experience delivering premium sports flooring and wooden court solutions for schools, academies, clubs, universities and professional badminton facilities across India.",
      },

      {
        title: "100+ Sports Projects",
        description:
          "Successfully completed 100+ sports flooring projects, including badminton courts, indoor sports arenas, training academies, schools, clubs and multi-purpose sports facilities.",
      },

      {
        title: "Premium Sports-Grade Hardwood",
        description:
          "We use high-quality hardwood selected for durability, dimensional stability, consistent performance and suitability for demanding badminton environments.",
      },

      {
        title: "Superior Shock Absorption",
        description:
          "Our badminton flooring systems are designed to absorb impact and help reduce stress on players' knees, ankles and joints during jumps, lunges, landings and rapid movements.",
      },

      {
        title: "Excellent Grip & Footwork",
        description:
          "Professionally finished surfaces provide controlled traction and reliable grip, helping players perform quick footwork, lunges, sudden stops and directional changes with confidence.",
      },

      {
        title: "Consistent Playing Surface",
        description:
          "Precision installation creates a smooth and uniform court surface that supports predictable player movement and consistent playing performance across the entire badminton court.",
      },

      {
        title: "Professional Court Finishing",
        description:
          "Our flooring can be professionally sanded, sealed, coated and line-marked to create a clean, durable and professional badminton playing environment.",
      },

      {
        title: "Low-Impact Playing System",
        description:
          "The flooring system is designed with player comfort in mind, helping provide a more forgiving surface for repetitive jumping, landing and high-intensity badminton movements.",
      },

      {
        title: "Durable & Long-Lasting",
        description:
          "Sports-grade materials and professional finishing help the flooring withstand frequent training sessions, tournaments and continuous daily use in indoor badminton facilities.",
      },

      {
        title: "Custom Badminton Court Solutions",
        description:
          "We provide customized flooring solutions based on court requirements, number of courts, facility usage, subfloor conditions, design preferences and project budget.",
      },

      {
        title: "Professional Installation Team",
        description:
          "Our experienced team handles subfloor preparation, hardwood installation, sanding, finishing and court marking with careful attention to surface quality and installation precision.",
      },

      {
        title: "On-Time Project Delivery",
        description:
          "Our structured project management process ensures efficient execution and helps complete badminton flooring projects within committed timelines.",
      },

      {
        title: "Complete Project Support",
        description:
          "From consultation and site assessment to flooring installation, court marking, maintenance guidance and after-sales assistance, we provide complete project support.",
      },

      {
        title: "Maintenance & After-Sales Support",
        description:
          "We provide practical maintenance recommendations and ongoing support to help preserve the flooring's appearance, grip, durability and playing performance.",
      },
    ],
  },

  /* =====================================================
     FAQ
  ====================================================== */

  faqs: [
    {
      question:
        "Which surface material offers the best performance for players?",
      answer:
        "PVC mats(Synthetic mats) over a wooden subfloor offer the best shock absorption and grip. Area-elastic hardwood systems are excellent durable options for multi-sports halls.",
    },

    {
      question:
        "What are the exact dimensions required to clear a standard court?",
      answer:
        "A standard courts needs a total footprint of 14.72 meters by 7.1 meters.This includes the 13.4m X 6.1m play area plus minimum safety boundaries.",
    },

    {
      question: "What is the ideal lighting design to prevent player glare?",
      answer:
        "Position LED floodlights along the side of the court, never directly above the playing area.Aim for 300 to 500 lux for recretion and over 1000 lux for professional tournaments.",
    },

    {
      question:
        "What is the minimum celing height needed for a badminton hall?",
      answer:
        "International competitions require a clear height of 12 meters above the floor surface.National or local community courts can operate with a 9-meter minimum height.",
    },
  ],

  /* =====================================================
       RELATED SERVICES
    ====================================================== */

  relatedServices: [
    {
      icon: GiTennisCourt,
      title: "Tennis Court",
      description: "Professional ITF Standard Courts",
      link: "/services/tennis-court",
    },

    {
      icon: FaBaseballBall,
      title: "Basketball Court",
      description: "Professional FIBA Standard Courts",
      link: "/services/basketball-court",
    },

    {
      icon: FaRunning,
      title: "Running Track",
      description: "Athletic Running Track Systems",
      link: "/services/running-track",
    },

    {
      icon: FaVolleyballBall,
      title: "Volleyball Court",
      description: "Professional FIVB Standard Courts",
      link: "/services/volleyball-court",
    },
  ],
  /* =====================================================
     CTA
  ====================================================== */

  cta: {
    title: "Ready to Build Your Basketball Court?",

    description:
      "Talk with our experts today and get a free consultation for your next sports infrastructure project.",
  },
};

export default badmintonData;
